const HandleSelectionChange = (
    setSelectedOnboardingOptions,
    setErrorStates,
    memoizedDispatch,
    setMacAppId
) => {


  const handleSelectedPortFolioChange = (selectedPortfolio) => {
    const emptySelection = { id: "", label: "", value: "" };
    const errorState = { isError: false, errorMessage: "" };



    setSelectedOnboardingOptions((currentSelectedOnboardingOptions) => ({
      ...currentSelectedOnboardingOptions,
      selectedPortfolio,
      selectedPlatform: emptySelection,
      selectedProduct: emptySelection,
      selectedApp: emptySelection,
    }));

    setErrorStates((currentErrorStates) => ({
      portfolio: errorState,
      platform: errorState,
      product: errorState,
      app: errorState,
    }));

    if(typeof memoizedDispatch === "function"){
        const fields = ["portfolio", "platform", "product", "app"];
        fields.forEach((field) => {
          const payload = field === "portfolio" ? selectedPortfolio : emptySelection;
          memoizedDispatch({
            type: "HANDLE EDITOR CHANGE",
            field,
            payload,
          });
        });
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "changedFileds",
          payload: (prev) => ({ ...prev, portfolio: true, platform: false, product: false, app: false }),
        });
    }

  };

  const handleSelectedPlatformChange = (selectedPlatform) => {


    const emptySelection = { id: "", label: "", value: "" };
    const errorState = { isError: false, errorMessage: "" };

    setSelectedOnboardingOptions((currentSelectedOnboardingOptions) => ({
      ...currentSelectedOnboardingOptions,
      selectedPlatform,
      selectedProduct: emptySelection,
      selectedApp: emptySelection,
    }));

    setErrorStates((currentErrorStates) => ({
      ...currentErrorStates,
      platform: errorState,
      product: errorState,
      app: errorState,
    }));


     if(typeof memoizedDispatch === "function"){
        const fields = ["platform", "product", "app"];
        fields.forEach((field) => {
          const payload = field === "platform" ? selectedPlatform : emptySelection;
          memoizedDispatch({
            type: "HANDLE EDITOR CHANGE",
            field,
            payload,
          });
        });
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "changedFileds",
          payload: (prev) => ({ ...prev, platform: true, product: false, app: false }),
        });
     }

  };


  const handleSelectedProductChange = (selectedProduct) => {
    const emptySelection = { id: "", label: "", value: "" };
    const errorState = { isError: false, errorMessage: "" };
  
    setSelectedOnboardingOptions((currentSelectedOnboardingOptions) => ({
      ...currentSelectedOnboardingOptions,
      selectedProduct,
      selectedApp: emptySelection,
    }));
  
    setErrorStates((currentErrorStates) => ({
      ...currentErrorStates,
      product: errorState,
      app: errorState,
    }));


    if(typeof memoizedDispatch === "function"){
        const fields = ["product", "app"];
        fields.forEach((field) => {
          const payload = field === "product" ? selectedProduct : emptySelection;
          memoizedDispatch({
            type: "HANDLE EDITOR CHANGE",
            field,
            payload,
          });
        });
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "changedFileds",
          payload: (prev) => ({ ...prev, product: true, app: false }),
        });
    }

  };

  const handleSelectedAppChange = (selectedApp) => {

    // if(!selectedApp.id){
    //   selectedApp["id"] = mac
    // }

    setSelectedOnboardingOptions((currentSelectedOnboardingOptions) => {
      return {
        ...currentSelectedOnboardingOptions,
        selectedApp: selectedApp,
      };
    });

    if(typeof memoizedDispatch === "function"){
        memoizedDispatch({
            type: "HANDLE EDITOR CHANGE",
            field: "app",
            payload: {
              ...selectedApp,
            },
          });
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "changedFileds",
          payload: (prev) => ({ ...prev, app: true }),
        });
    }

  };



const handleMacAppIdChange = (macAppId) => {
setMacAppId( macAppId.target.value)

if(typeof memoizedDispatch === "function"){
  memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "application_id",
      payload: {
        value: macAppId.target.value,
      },
    });
}

  }

  const handleMvcVulnerabilityChange = (selectedValues) => {
    setSelectedOnboardingOptions((currentSelectedOnboardingOptions) => {
      return {
        ...currentSelectedOnboardingOptions,
        mvcVulnerabilityRelated: selectedValues,
      };
    });

    setErrorStates((currentErrorStates) => ({
      ...currentErrorStates,
      mvcVulnerabilityRelated: {
        isError: false,
        errorMessage: "",
      },
    }));

    if(typeof memoizedDispatch === "function"){
      memoizedDispatch({
        type: "HANDLE EDITOR CHANGE",
        field: "mvcVulnerabilityRelated",
        payload: selectedValues || [],
      });
    }
  };

  return { handleSelectedPortFolioChange, handleSelectedPlatformChange, handleSelectedProductChange, handleSelectedAppChange, handleMacAppIdChange, handleMvcVulnerabilityChange };
};

export default HandleSelectionChange;